<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 35vw">
      <div class="modal-header">
        <h5 class="modal-title">Reset Password</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body">
        <!-- STEP 1: ASK FOR EMAIL -->
        <div v-if="step === 1">
          <p class="info-text">Enter your registered email or username.</p>

          <div class="form-group">
            <label>Email / Username</label>
            <input
              v-model="email"
              type="text"
              class="form-control"
              placeholder="Enter email or username"
            />
          </div>

          <button
            class="btn btn-primary w-100 mt-3"
            @click="sendOTP"
            :disabled="loading"
          >
            <span v-if="loading">Sending...</span>
            <span v-else>Continue</span>
          </button>
        </div>

        <!-- STEP 2: OTP + New Password -->
        <div v-if="step === 2">
          <p class="info-text">
            An OTP has been sent to your registered phone number and/or email.
          </p>

          <!-- OTP INPUT + RESEND BTN -->
          <div class="form-group otp-row">
            <div class="flex-1">
              <label>Enter OTP</label>
              <!-- <input
                v-model="otp"
                type="text"
                class="form-control"
                placeholder="123456"
              /> -->
              <!-- Decoy field to prevent autofill -->
              <input
                type="text"
                name="fake-otp-decoy"
                autocomplete="off"
                tabindex="-1"
                style="
                  position: absolute;
                  opacity: 0;
                  height: 0;
                  width: 0;
                  pointer-events: none;
                "
              />

              <!-- Actual OTP input -->
              <input
                v-model="otp"
                type="text"
                inputmode="numeric"
                autocomplete="one-time-code"
                class="form-control"
                placeholder="Enter OTP"
              />
            </div>

            <button
              class="btn btn-outline-secondary resend-btn"
              @click="resendOTP"
              :disabled="resending"
            >
              <span v-if="resending">Sending...</span>
              <span v-else>Resend OTP</span>
            </button>
          </div>

          <!-- NEW PASSWORD -->
          <div class="form-group">
            <label>New Password</label>
            <input
              v-model="password"
              type="password"
              class="form-control"
              placeholder="Enter new password"
            />
          </div>

          <!-- CONFIRM PASSWORD -->
          <div class="form-group">
            <label>Re-enter Password</label>
            <input
              v-model="confirmPassword"
              type="password"
              class="form-control"
              placeholder="Re-enter password"
            />
            <p v-if="passwordMismatch" class="error-msg">
              Passwords do not match.
            </p>
          </div>

          <div class="footer-row">
            <button
              class="btn btn-success"
              @click="submitReset"
              :disabled="passwordMismatch || loading2"
            >
              <span v-if="loading2">Submitting...</span>
              <span v-else>Submit</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../api/apiIndex";
import showNotification from "../notification/notify";
export default {
  name: "ForgotPasswordModal",

  data() {
    return {
      step: 1,

      email: "",
      otp: "",
      password: "",
      confirmPassword: "",

      loading: false,
      loading2: false,
      resending: false,
    };
  },

  computed: {
    passwordMismatch() {
      return (
        this.password !== "" &&
        this.confirmPassword !== "" &&
        this.password !== this.confirmPassword
      );
    },
  },

  methods: {
    closeModal() {
      this.$emit("close-pass");
    },

    // Fake API: Send OTP
    async sendOTP() {
      if (this.email.trim() === "") {
        showNotification("Enter a Valid Email", "error");
        return;
      }

      this.loading = true;
      const body = { username: this.email };
      const resp = await generalApiRequest(
        "send_change_password_otp",
        "POST",
        body,
        1
      );
      if (resp) {
        this.loading = false;
        this.step = 2;
      }
    },

    // Fake API: Resend OTP
    async resendOTP() {
      this.resending = true;
      await this.sendOTP();
      this.resending = false;
    },

    // Fake API: Submit Reset Password
    async submitReset() {
      if (this.passwordMismatch) return;

      this.loading2 = true;

      const req_body = {
        username: this.email,
        otp: this.otp,
        password: this.password,
      };

      const resp = await generalApiRequest(
        "change_user_password",
        "POST",
        req_body,
        1
      );
      showNotification(resp.status);
      this.loading2 = false;
      this.closeModal();
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5000;
}

.modal-content {
  background: white;
  border-radius: 10px;
  padding-bottom: 20px;
  width: 100%;
  animation: fadeIn 0.2s;
}

.modal-header {
  padding: 15px;
  background: #f7f7f7;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
}

.modal-title {
  font-size: 1.2rem;
  font-weight: bold;
}

.close {
  background: red;
  border: none;
  color: white;
  padding: 3px 10px;
  font-size: 1.3rem;
  cursor: pointer;
  border-radius: 5px;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-control {
  width: 100%;
  padding: 9px 12px;
  border-radius: 7px;
  border: 1px solid #bbb;
}

.info-text {
  font-size: 0.9rem;
  background: #eef7ff;
  padding: 10px;
  border-left: 3px solid #0d6efd;
  margin-bottom: 15px;
  border-radius: 6px;
}

.otp-row {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}

.flex-1 {
  flex: 1;
}

.resend-btn {
  height: 40px;
  white-space: nowrap;
}

.error-msg {
  color: red;
  margin-top: 5px;
  font-size: 0.85rem;
}

.footer-row {
  text-align: right;
  margin-top: 20px;
}
</style>
